/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ImportCatalogFromUrlRequest,
  ImportCatalogXLSX200Response,
  ImportCatalogXLSX400Response,
} from '../models/index';
import {
    ImportCatalogFromUrlRequestFromJSON,
    ImportCatalogFromUrlRequestToJSON,
    ImportCatalogXLSX200ResponseFromJSON,
    ImportCatalogXLSX200ResponseToJSON,
    ImportCatalogXLSX400ResponseFromJSON,
    ImportCatalogXLSX400ResponseToJSON,
} from '../models/index';

export interface ImportCatalogFromUrlOperationRequest {
    importCatalogFromUrlRequest: ImportCatalogFromUrlRequest;
}

/**
 * 
 */
export class ImportCatalogApi extends runtime.BaseAPI {

    /**
     */
    async importCatalogFromUrlRaw(requestParameters: ImportCatalogFromUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportCatalogXLSX200Response>> {
        if (requestParameters['importCatalogFromUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'importCatalogFromUrlRequest',
                'Required parameter "importCatalogFromUrlRequest" was null or undefined when calling importCatalogFromUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/import/url`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportCatalogFromUrlRequestToJSON(requestParameters['importCatalogFromUrlRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportCatalogXLSX200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async importCatalogFromUrl(requestParameters: ImportCatalogFromUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportCatalogXLSX200Response> {
        const response = await this.importCatalogFromUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async importCatalogXLSXRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportCatalogXLSX200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/import/xlsx`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportCatalogXLSX200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async importCatalogXLSX(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportCatalogXLSX200Response> {
        const response = await this.importCatalogXLSXRaw(initOverrides);
        return await response.value();
    }

}
